import React from 'react';
import PropTypes from 'prop-types';
// Components
import WebchatCtaDecorated from '../webchat/cta';
import CTA from './cta';
import actions from './actions';

import { consistentString } from '../../utils/content-formatting';

export const CTAAssembly = ({ contentfulData, className, marginBottom }) => {
  if (contentfulData.type === 'Webchat') {
    return (
      <WebchatCtaDecorated
        icon={contentfulData.icon}
        heading={contentfulData.buttonText}
      />
    );
  }

  const handleClick = () => {
    const javascriptAction =
      actions[process.env.SHELTER_SITE][contentfulData.contentful_id];
    if (javascriptAction) {
      javascriptAction();
    }
  };

  return (
    <CTA
      type={consistentString(contentfulData.ctaType)}
      bg={consistentString(contentfulData.ctaColor)}
      className={className}
      link={contentfulData.link}
      icon={
        consistentString(contentfulData.icon) !== 'default'
          ? consistentString(contentfulData.icon)
          : null
      }
      iconPlacement={contentfulData.iconPlacement}
      fullWidth={contentfulData.fullWidth}
      externalUrl={contentfulData.externalUrl}
      dataTracking={contentfulData.dataTracking}
      size={contentfulData.size}
      onClick={handleClick}
      marginBottom={marginBottom === undefined ? true : marginBottom}
    >
      {contentfulData.buttonText}
    </CTA>
  );
};

CTAAssembly.propTypes = {
  contentfulData: PropTypes.object,
  className: PropTypes.string,
  marginBottom: PropTypes.bool,
};
export default CTAAssembly;
